import Payment from "assets/menu-icons/Payment";

const payment = {
  id: 'payment',
  type: 'group',
  children: [{
    id: 'payment',
    title: 'Мои счета', 
    type: 'item',
    url: '/payment',
    icon: Payment,
    breadcrumbs: false
  }]
}

export default payment;
